// __TIME_WINDOWS__ (2026-10-08) Henry: every job dated TODAY OR LATER must have a pickup window
// (start + end) on its first pickup stop. Historic jobs are exempt; an undated job is not "dated".
// A whole-day 00:00-23:59 (what a dated booking with no times got) is not a window.
// Twin of the hub's time_windows.required_problem (Billing-Manager/time_windows.py). Pure.
export const TIME_WINDOW_RULE = 'Every job dated today or later needs a pickup window (from - to): set the first pickup stop\'s Earliest and Latest Time.';

function hm(v) {
  let s = String(v || '').trim();
  if (s.includes('T')) s = s.split('T')[1];
  else if (/^\d{4}-\d{2}-\d{2} /.test(s)) s = s.slice(11);
  const m = /^([01]?\d|2[0-3]):([0-5]\d)/.exec(s);
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
}

export function localToday(now = new Date()) {
  return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
}

// null when the job may be saved, else the sentence. pickupStops: the pickup stops in order (address filled).
export function pickupWindowProblem(scheduledDate, pickupStops, today = localToday()) {
  const day = String(scheduledDate || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day) || day < today) return null;
  const first = (pickupStops || [])[0];
  if (!first) return null;               // no pickup stop: the "pickup address is required" check speaks
  const f = hm(first.time_window_start), t = hm(first.time_window_end);
  if (f == null || t == null || (f === 0 && t === 23 * 60 + 59)) return TIME_WINDOW_RULE;
  if (t <= f) return 'The pickup window ends before it starts.';
  return null;
}
